(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-chat-gutenberg-block', {

        // Block setup
        title: __('Discord Chat', 'discord-wordpress-plugin'),
        description: __( 'Widget displaying chat from channel.', 'discord-wordpress-plugin' ),
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#9fda72" d="M333.231 0H27.7694C20.4068 0.00686992 13.3478 2.77238 8.14162 7.6896C2.93545 12.6068 0.00744086 19.274 0.000167254 26.228V286.587C-0.0182249 291.589 1.48062 296.492 4.31941 300.715C7.1582 304.938 11.2182 308.305 16.0191 310.417C20.82 312.53 26.161 313.299 31.4103 312.635C36.6597 311.97 41.5977 309.9 45.6404 306.668L100.758 262.895L333.231 262.28C340.593 262.273 347.652 259.508 352.859 254.591C358.065 249.673 360.993 243.006 361 236.052V26.228C360.993 19.274 358.065 12.6068 352.859 7.68959C347.652 2.77237 340.593 0.00686558 333.231 0ZM97.1907 150.824C93.0715 150.824 89.0449 149.67 85.6199 147.509C82.1949 145.347 79.5255 142.275 77.9491 138.681C76.3728 135.086 75.9604 131.131 76.764 127.315C77.5676 123.499 79.5511 119.994 82.4638 117.243C85.3765 114.492 89.0875 112.619 93.1276 111.86C97.1676 111.101 101.355 111.49 105.161 112.979C108.966 114.468 112.219 116.989 114.508 120.224C116.796 123.459 118.018 127.262 118.018 131.153C118.018 136.37 115.823 141.373 111.918 145.062C108.012 148.751 102.714 150.824 97.1907 150.824ZM180.498 150.824C176.379 150.824 172.353 149.67 168.928 147.509C165.503 145.347 162.833 142.275 161.257 138.681C159.68 135.086 159.268 131.131 160.072 127.315C160.875 123.499 162.859 119.994 165.771 117.243C168.684 114.492 172.395 112.619 176.435 111.86C180.475 111.101 184.663 111.49 188.468 112.979C192.274 114.468 195.527 116.989 197.815 120.224C200.104 123.459 201.325 127.262 201.325 131.153C201.325 136.37 199.131 141.373 195.225 145.062C191.319 148.751 186.022 150.824 180.498 150.824ZM263.806 150.824C259.687 150.824 255.66 149.67 252.235 147.509C248.81 145.347 246.141 142.275 244.564 138.681C242.988 135.086 242.576 131.131 243.379 127.315C244.183 123.499 246.166 119.994 249.079 117.243C251.992 114.492 255.703 112.619 259.743 111.86C263.783 111.101 267.97 111.49 271.776 112.979C275.582 114.468 278.834 116.989 281.123 120.224C283.411 123.459 284.633 127.262 284.633 131.153C284.633 136.37 282.439 141.373 278.533 145.062C274.627 148.751 269.33 150.824 263.806 150.824Z"/>
                <rect x="238" y="238" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            color: {
                type: 'string',
                default: 'dwpp_widget_theme_light',
            },
            channel: {
                type: 'string',
                default: '0',
            },
            title: {
                type: 'string',
                default: __('Discord Chat', 'discord-wordpress-plugin'),
            },
            tenorMessages: {
                type: 'string',
                default: 'video',
            },
            pinnedMessages: {
                type: 'string',
                default: 'no_filter',
            },
            imageMessages: {
                type: 'string',
                default: 'image',
            },
            linkMessages: {
                type: 'string',
                default: 'link',
            },
            customEmojiMessages: {
                type: 'string',
                default: 'image',
            },
            quantity: {
                type: 'integer',
                default: 20,
            },
            height: {
                type: 'integer',
                default: 350,
            },
            footer_text: {
                type: 'string',
                default: __('Join our server', 'discord-wordpress-plugin'),
            },
            link: {
                type: 'string',
                default: '0',
            },
            messages: {
                type: 'object',
                default: {
                    length: 0
                },
            },
            channels: {
                type: 'object',
                default: {
                    length: 0
                },
            },
            updateHash: {
                type: 'string',
                default: '',
            }
        },
        example: {
            attributes: {
                quantity: 10,
            },
        },


        // Main editor function
        edit: props => {

            // Updating channels list
            if (props.attributes.channels.length === 0) {
                $.get( ajaxurl, { action: 'dwpp_getAllChannelsList' } )
                    .done( response => {
                        let channels = [];
                        if (response.data.channels) {
                            response.data.channels.forEach(element => {
                                channels.push({
                                    value: element.id,
                                    label: element.name
                                });
                            });
                        }
                        props.setAttributes({ channels: channels });
                    });

                return __('Loading...', 'discord-wordpress-plugin');
            }

            if (!props.attributes.channel || props.attributes.channel === '0') {
                props.setAttributes({channel: props.attributes.channels[0].value});
            }


            // Updating messages
            let newUpdateHash = props.attributes.channel + props.attributes.quantity + props.attributes.customEmojiMessages + props.attributes.imageMessages + props.attributes.linkMessages + props.attributes.tenorMessages + props.attributes.pinnedMessages;
            if (props.attributes.updateHash !== newUpdateHash || props.attributes.messages.length === 0) {
                props.setAttributes({ updateHash: newUpdateHash });
                $.get(ajaxurl, {
                        action: 'dwpp_getInterpretedMessages',
                        channel: props.attributes.channel,
                        quantity: props.attributes.quantity,
                        custom_emoji: props.attributes.customEmojiMessages === 'image',
                        images: props.attributes.imageMessages === 'image',
                        links: props.attributes.linkMessages === 'link',
                        tenor: props.attributes.tenorMessages === 'video',
                        pinned: props.attributes.pinnedMessages === 'only_pinned'
                    })
                    .done(response => props.setAttributes({ messages: response.data.message }) );
            }


            let inviteChannels = [{
                value: '0',
                label: __('Do not invite', 'discord-wordpress-plugin')
            }].concat( props.attributes.channels );

            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Colors', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ color: value }) }
                                    options={[
                                        { value: 'dwpp_widget_theme_light', label: __('Light Style', 'discord-wordpress-plugin') },
                                        { value: 'dwpp_widget_theme_dark', label: __('Dark Style', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.color }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Title', 'discord-wordpress-plugin') }
                                    value={ props.attributes.title }
                                    onChange={ value => props.setAttributes({ title: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Get messages from', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ channel: value }) }
                                    options={ props.attributes.channels }
                                    value={ props.attributes.channel }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Only pinned messages', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ pinnedMessages: value }) }
                                    options={[
                                        { value: 'no_filter', label: __('Do not filter', 'discord-wordpress-plugin') },
                                        { value: 'only_pinned', label: __('Only pinned', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.pinnedMessages }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Tenor messages', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ tenorMessages: value }) }
                                    options={[
                                        { value: 'video', label: __('Show video', 'discord-wordpress-plugin') },
                                        { value: 'link', label: __('Show link', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.tenorMessages }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Images in messages', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ imageMessages: value }) }
                                    options={[
                                        { value: 'image', label: __('Show image', 'discord-wordpress-plugin') },
                                        { value: 'link', label: __('Show link', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.imageMessages }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Custom emoji in messages', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ customEmojiMessages: value }) }
                                    options={[
                                        { value: 'image', label: __('Show image', 'discord-wordpress-plugin') },
                                        { value: 'hide', label: __('Hide', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.customEmojiMessages }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Links', 'discord-wordpress-plugin') }
                                    help={ __('Display images and Tenor as text links if they are disabled', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ linkMessages: value }) }
                                    options={[
                                        { value: 'link', label: __('Display as text', 'discord-wordpress-plugin') },
                                        { value: 'hide', label: __('Hide', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.linkMessages }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Quantity', 'discord-wordpress-plugin') }
                                    value={ props.attributes.quantity }
                                    type={'number'}
                                    onChange={ value => props.setAttributes({ quantity: (parseInt(value) < 1 || parseInt(value) > 50) ? 20 : value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Height', 'discord-wordpress-plugin') }
                                    value={ props.attributes.height }
                                    type={'number'}
                                    onChange={ value => props.setAttributes({ height: parseInt(value) > 200 ? value : 200 }) }/>
                            </PanelRow>
                            <PanelRow>
                                <TextControl
                                    label={ __('Footer text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.footer_text }
                                    onChange={ value => props.setAttributes({ footer_text: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Invite to channel', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ link: value }) }
                                    options={ inviteChannels }
                                    value={ props.attributes.link }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <div className={ "dwpp_widget dwpp_widget_chat " + props.attributes.color }>
                    { props.attributes.title ?
                        <div className="dwpp_widget__header">
                            <img className="dwpp_widget__logo"
                                 src="/wp-content/plugins/discord-wordpress-plugin/view/style/discord/images/icon-white.svg"
                                 height="34"/>
                            <span className="dwpp_widget__title">
                                { props.attributes.title }
                            </span>
                        </div>
                        : ''
                    }
                    <div className="dwpp_widget__body" style={{ maxHeight: props.attributes.height }}>

                        { props.attributes.messages.length ?
                            <ul className="dwpp_widget__chat">
                                { props.attributes.messages.map( (message) => {
                                    if (message.fetched.type === 0 && message.content) return <li>
                                        <span className="dwpp_widget__chat_avatar">
                                            <img
                                                className="dwpp_widget__avatar"
                                                src={ message.avatar }
                                                width="16"
                                                height="16"/>
                                        </span>
                                        <span className="dwpp_widget__chat_name">
                                            { message.name }
                                        </span>
                                        <span/>
                                        <span
                                            className="dwpp_widget__chat_message"
                                            dangerouslySetInnerHTML={{ __html: message.content }}/>
                                    </li>;
                                }) }
                            </ul>
                            :
                            __('No messages found', 'discord-wordpress-plugin')
                        }

                    </div>


                    { props.attributes.footer_text || props.attributes.link !== '0' ?
                        <div className="dwpp_widget__footer">
                            <div className="dwpp_widget__footer__text">
                                { props.attributes.footer_text }
                            </div>

                            { props.attributes.link && props.attributes.link !== '0' ?
                                <a className="dwpp_widget__button">
                                    { __('Connect', 'discord-wordpress-plugin') }
                                </a>
                                : ''
                            }
                        </div>
                        : ''
                    }
                </div>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
